import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';
import { Spinner } from '../components/Spinner.jsx';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <Spinner />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
}
